export default __webpack_public_path__ + "static/media/ssapMarketV1.168589fb.svg";